module.exports = __webpack_public_path__ + "static/img/fuwuzixun_bg.19bb0385.png";